/**
 * Contratos zod del endpoint Operaciones (despachos y recepciones).
 */

import { z } from 'zod';
import {
  ESTADOS_ANMAT,
  TIPOS_MENSAJE_SNT,
  TIPOS_OPERACION,
  TIPOS_EVENTO_MOV,
} from '@/domain/types';

export const TipoOperacionSchema = z.enum(TIPOS_OPERACION);
export const EstadoAnmatSchema = z.enum(ESTADOS_ANMAT);
export const TipoMensajeSntSchema = z.enum(TIPOS_MENSAJE_SNT);
export const TipoEventoMovSchema = z.enum(TIPOS_EVENTO_MOV);

export const AnmatErrorSchema = z.object({
  code: z.string(),
  msg: z.string(),
  severidad: z.enum(['bajo', 'medio', 'alto']),
  ts: z.string().datetime(),
});

export const AnmatMessageSchema = z.object({
  ts: z.string().datetime(),
  tipo: z.enum(['request', 'response']),
  body: z.string(),
});

export const AnmatPayloadSchema = z.object({
  tipoMensaje: TipoMensajeSntSchema,
  estado: EstadoAnmatSchema,
  intentos: z.number().int().nonnegative(),
  codigoTransaccion: z.string().nullable(),
  ultimoError: AnmatErrorSchema.optional(),
  mensajes: z.array(AnmatMessageSchema),
});

export const OperacionSchema = z.object({
  id: z.string().min(1),
  tipo: TipoOperacionSchema,
  ubicacionId: z.string().min(1),
  destinoUbicacionId: z.string().optional(),
  opOrigenId: z.string().optional(),
  operacionOrigenId: z.string().optional(),
  remitoNumero: z.string().nullable(),
  eventoAnmatId: z.number().int().nullable(),
  fecha: z.string().datetime(),
  usuarioId: z.string().min(1),
  seriesIds: z.array(z.string()),
  estado: z.enum(['abierta', 'cerrada']),
  anmat: AnmatPayloadSchema,
  pdfGeneradoAt: z.string().datetime().nullable().optional(),
  fechaCancelacion: z.string().datetime().optional(),
});

export const MovimientoSchema = z.object({
  id: z.string().min(1),
  serieId: z.string().min(1),
  operacionId: z.string().nullable(),
  tipoEvento: TipoEventoMovSchema,
  fecha: z.string().datetime(),
  ubicacionId: z.string().min(1),
  usuarioId: z.string().nullable(),
  codigoTransaccion: z.string().nullable(),
  eventoAnmatId: z.number().int().nullable(),
  detalle: z.string(),
  ingresoId: z.string().optional(),
});

export const GetOperacionesResponse = z.array(OperacionSchema);
export const GetMovimientosResponse = z.array(MovimientoSchema);

export type Operacion = z.infer<typeof OperacionSchema>;
export type Movimiento = z.infer<typeof MovimientoSchema>;
